/** Do not add english translations here, unless key-value are not the same */
const en: { [key: string]: string } = {}
export default en
